import React, { useCallback, useEffect } from 'react'
import { useBootstrap } from '~/store/auth/useBootstrap'
import { clearAuthorizationToken, clearRefreshToken } from '~/service/api'
import { useSignOut } from '~/store/auth/useSignOut'
import { LoadingState } from '..'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

export type BootstrapProps = {
  onComplete: () => void
}

const useStyles = makeStyles({
  content: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh'
  }
})

export const Bootstrap: React.FC<BootstrapProps> = (props) => {
  const classes = useStyles()
  const { onComplete } = props

  const signOut = useSignOut()
  const [authState, bootstrap] = useBootstrap()

  const { loading } = authState

  const bootUser = useCallback(async () => {
    const success = await bootstrap()

    if (!success) {
      clearAuthorizationToken()
      clearRefreshToken()
      signOut()
      return // ***
    }

    onComplete()
  }, [onComplete, bootstrap, signOut])

  useEffect(() => {
    bootUser()
  }, [bootUser])

  if (loading) {
    return (
      <Box className={classes.content}>
        <LoadingState />
      </Box>
    )
  }

  return null
}
